
import { computed, defineComponent } from 'vue';

export default defineComponent({
  name: 'HelloWorld',
  props: {
    msg: String,
  },
  data() {
    return {
      got: {},
      email: "",
      password: "",
      status: ""
    }
  },
  async created() {
  // GET request using fetch with async/await
  const response = await fetch("http://localhost:3000/user");
  const data = await response.json();
  this.got = data;
  this.email = data["email"]
  this.password = data["password"]
  },
  methods: {
    async createUser() {
      const datas = { email: this.email,
          password: this.password
      };
      const requestOptions = {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(datas)
      };
      console.log(requestOptions);
      const response = await fetch("http://localhost:3000/user/post", requestOptions);
      const data = await response.json();
      console.log(data)
      this.got = await data; 
      this.status = `Сервер получил email ${data.email} и следующий пароль ${data.password} вернув их обратно`
    },
    async clearUsers() {
      const response = await fetch("http://localhost:3000/user/clear");
      const data = await response.json();
      this.got = await data; 
    }
  }
});
